// Runs for both the editable checkout and Commerce's pending-payment screen.
export function checkoutStatus() {
    const scope = document.querySelector('.checkout');
    if (!scope || !document.getElementById('novastars-checkout-config')) return;
    scope.querySelectorAll('[data-dismiss-after]').forEach(notice => {
        window.setTimeout(() => { notice.hidden = true; }, Number(notice.dataset.dismissAfter));
    });
    scope.addEventListener('click', event => {
        const close = event.target.closest('.checkout-notice-close');
        if (close) close.closest('.checkout-notice').hidden = true;
    });

    // Commerce has already processed the provider return on the server.
    // Do not replay transaction callbacks when reloading the one-page checkout.
    const url = new URL(window.location.href);
    if (url.searchParams.get('step') !== 'thank-you') {
        ['step', 'transaction', 'cancel_transaction', 'payment_intent',
            'payment_intent_client_secret', 'redirect_status', '_attempt', 'retry', 'complete_free']
            .forEach(key => url.searchParams.delete(key));
        if (url.href !== window.location.href) window.history.replaceState(window.history.state, '', url.href);
    }
    if (scope.querySelector('[data-payment-pending]')) {
        // Explicit GET also avoids resubmitting a previous POST on refresh.
        window.setTimeout(() => window.location.assign(url.href), 10000);
    }
}
